import useSWR from "swr";
import { configLibraryUrl } from "@/utils/Config";
import { type Library } from "@/utils";

export function useTemplateLibrary() {
  const { data, error } = useSWR<Library>(
    `${configLibraryUrl}/manifest_v3.json`,
    (url: string) => fetch(url).then((res) => res.json())
  );
  if (error) console.error(error);
  return data;
}
